import { EXPERIMENT_COHORTS } from '@strava/constants';

export const isNavSignUpVariantA = (experiment) =>
  experiment?.name === 'logged-out-navigation-signup-modals' &&
  experiment?.cohort === EXPERIMENT_COHORTS.variantA;

export default { isNavSignUpVariantA };
